module.exports = __webpack_public_path__ + "media/svg-new/avatar-12 2-64478ea5.svg";